<template>
  <div class="gp-content profile-analytics">
    <content-nav-bar>
      <a @click.prevent="submit" class="level-item button add">
        <i class="far fa-save"></i>
        Save Profile Analytics
      </a>
      <p v-if="message" class="level-item">{{ message }}</p>
      <analytics-filter-bar
        ref="filterBar"
        :filter.sync="filter"
        :digita.sync="digita"
        :categories="categories"
        :tags="tags"
        :actions="actions">
      </analytics-filter-bar>
      <template slot="right">
        <loader class="level-item" :showLoader="showLoader"></loader>
      </template>
    </content-nav-bar>
    <analytics-table
      class="scroll-vertical full-height"
      :analytics="filteredAnalytics"
      :select="true"
      :selected.sync="internalSelected"
      v-on:analytic-table-tag-click="$refs.filterBar.addTagFilter($event.tag)"
      v-on:analytic-table-cat-click="$refs.filterBar.addCatFilter($event.cat)"
      v-on:analytic-table-action-click="$refs.filterBar.addActionFilter($event.action)">
    </analytics-table>
  </div>
</template>

<script>
import _ from 'lodash';
import analyticsFilter from '@/mixins/analyticsFilter';
import Loader from '@/components/Loader.vue';
import AnalyticsTable from '@/components/analytics/AnalyticsTable.vue';
import AnalyticsFilterBar from '@/components/analytics/AnalyticsFilterBar.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'ProfileAnalytics',
  mixins: [analyticsFilter],
  components: {
    AnalyticsTable,
    Loader,
    ContentNavBar,
    AnalyticsFilterBar,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selected() {
      const selected = _.map(this.profile.analytics, 'uuid');
      return selected;
    },
    payload() {
      return {
        id: this.profile.id,
        analytics: _.map(this.internalSelected, 'uuid'),
      };
    },
    showNewMessage() {
      return Object.prototype.hasOwnProperty.call(this.$route.query, 'new');
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      await this.$store.dispatch('primary/setProfileAnalytics', this.payload);
      this.showLoader = false;
      this.message = 'Profile was updated';
    },
  },
  async mounted() {
    this.analytics = await this.$store.dispatch('primary/listAnalytics');
  },
  data() {
    return {
      showLoader: false,
      analytics: null,
      internalSelected: this.profile.analytics,
      message: 'Select or deselect analytics to make changes',
    };
  },
};
</script>

<style lang="scss" scoped>
.profile-analytics {
  flex-grow: 1;
}

.full-height {
  height: 100%;
}
</style>
